import React from "react";

function GreenCheck() {
  return (
    <>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.3125 0C5.86623 0 4.45243 0.428871 3.2499 1.23238C2.04736 2.03589 1.1101 3.17794 0.556634 4.51413C0.00316839 5.85031 -0.141643 7.32061 0.140511 8.7391C0.422665 10.1576 1.11911 11.4605 2.14178 12.4832C3.16446 13.5059 4.46742 14.2023 5.88591 14.4845C7.30439 14.7666 8.77469 14.6218 10.1109 14.0684C11.4471 13.5149 12.5891 12.5776 13.3926 11.3751C14.1961 10.1726 14.625 8.75878 14.625 7.3125C14.623 5.37373 13.8519 3.51496 12.481 2.14404C11.11 0.773127 9.25127 0.00204737 7.3125 0ZM10.523 6.02297L6.58547 9.96047C6.53323 10.0128 6.47119 10.0543 6.40291 10.0826C6.33462 10.1109 6.26142 10.1254 6.1875 10.1254C6.11358 10.1254 6.04039 10.1109 5.9721 10.0826C5.90381 10.0543 5.84178 10.0128 5.78953 9.96047L4.10203 8.27297C3.99649 8.16742 3.93719 8.02427 3.93719 7.875C3.93719 7.72573 3.99649 7.58258 4.10203 7.47703C4.20758 7.37148 4.35074 7.31219 4.5 7.31219C4.64927 7.31219 4.79242 7.37148 4.89797 7.47703L6.1875 8.76727L9.72703 5.22703C9.7793 5.17477 9.84134 5.13331 9.90962 5.10503C9.97791 5.07674 10.0511 5.06219 10.125 5.06219C10.1989 5.06219 10.2721 5.07674 10.3404 5.10503C10.4087 5.13331 10.4707 5.17477 10.523 5.22703C10.5752 5.27929 10.6167 5.34134 10.645 5.40962C10.6733 5.4779 10.6878 5.55109 10.6878 5.625C10.6878 5.69891 10.6733 5.7721 10.645 5.84038C10.6167 5.90866 10.5752 5.97071 10.523 6.02297Z"
          fill="#0A8900"
        />
      </svg>
    </>
  );
}

export default GreenCheck;
